export default "__VITE_ASSET__BOZFic1E__"